import { useEffect, useRef } from "react";

const useInactivityTracker = (callback: () => void, timeoutMs: number) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(callback, timeoutMs);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer(); // Initialize timer

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [callback, timeoutMs]);
};

export default useInactivityTracker;
